// ============================================================================
// ROLE ENDPOINTS
// ============================================================================
// Backend: RoleController → /api/v1/Role  → BASE_PATH = '/Role'.

import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

export const ROLE_BASE_PATH = '/Role';

export const roleEndpoints = {
  /** GET /api/v1/Role */
  list: () => buildEndpoint(ROLE_BASE_PATH),

  /** GET /api/v1/Role/:id */
  getById: (id: ID) =>
    buildEndpointWithParams(`${ROLE_BASE_PATH}/:id`, { id }),

  /** GET /api/v1/Role/code/:code */
  getByCode: (code: string) =>
    buildEndpointWithParams(`${ROLE_BASE_PATH}/code/:code`, { code }),

  /**
   * GET /api/v1/Role/by-roles?roles=a,b,c.
   * Returns the merged visibleModules + moduleActions across all named roles.
   * Marked [AllowAnonymous] on the server — called at login before the
   * role-permission engine is built.
   */
  byRoles: (roleCodes: string[]) =>
    `${buildEndpoint(ROLE_BASE_PATH)}/by-roles?roles=${encodeURIComponent(
      roleCodes.join(','),
    )}`,

  /** POST /api/v1/Role */
  create: () => buildEndpoint(ROLE_BASE_PATH),

  /** PUT /api/v1/Role/:id */
  update: (id: ID) =>
    buildEndpointWithParams(`${ROLE_BASE_PATH}/:id`, { id }),

  /** DELETE /api/v1/Role/:id — soft delete (rejects system roles with 409). */
  delete: (id: ID) =>
    buildEndpointWithParams(`${ROLE_BASE_PATH}/:id`, { id }),

  /** GET /api/v1/Role/validate/code/:code */
  validateCode: (code: string) =>
    buildEndpointWithParams(`${ROLE_BASE_PATH}/validate/code/:code`, { code }),
} as const;

export default roleEndpoints;
